import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);



export default new Vuetify({
    icons: {
      iconfont: 'md', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    },
    theme: {
      themes: {
        light: {
          primary: '#E92727', // #E53935
          secondary: '#DFA085', // #FFCDD2
          accent: '#e3c5b4'
        },
      },
    },
  });
  
